(function ($) {
	$(document).ready(function () {
		$(document).on(
			'change',
			'.posts-listing-filters-inner select',
			function (e) {
				e.preventDefault();

				const url = $(this).val();
				const block = $(this)
					.closest('.posts-listing')
					.first()
					.attr('id');

				if ($('#' + block).data('ajax')) {
					displayLoading(block);
					ajaxLoad(url, block);
				} else {
					window.location.href = url;
				}
			}
		);

		$(document).on(
			'click',
			'.posts-listing[data-ajax="true"] .pagination a',
			function (e) {
				e.preventDefault();

				const url = $(this).attr('href');
				const block = $(this)
					.closest('.posts-listing')
					.first()
					.attr('id');

				displayLoading(block);
				ajaxLoad(url, block);
			}
		);

		function ajaxLoad(url, block) {
			$.ajax({
				url,
				success: (response) => {
					updateBlock(response, block);
				},
			});
		}

		function displayLoading(block) {
			$('#' + block + ' .posts-listing-content').hide();
			$('#' + block + ' .posts-listing-loading').show();
			$('html,body').animate(
				{
					scrollTop: $('#' + block).position().top,
				},
				500
			);
		}

		function updateBlock(response, block) {
			$('#' + block + ' .posts-listing-content').html(
				$(response)
					.find('#' + block + ' .posts-listing-content')
					.html()
			);
			$('#' + block + ' .posts-listing-filters').html(
				$(response)
					.find('#' + block + ' .posts-listing-filters')
					.html()
			);
			$('#' + block + ' .posts-listing-loading').hide();
			$('#' + block + ' .posts-listing-content').show();
		}
	});
})(jQuery);
